import { render, staticRenderFns } from "./DietLength.vue?vue&type=template&id=05f45823&"
import script from "./DietLength.vue?vue&type=script&lang=js&"
export * from "./DietLength.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports